const MAX_RETRY_COUNT = 3;
const RETRYABLE_4XX_STATUS_CODES = new Set([
  408, // Request Timeout
  429, // Too Many Requests
]);

export const retry = (failureCount: number, error: unknown): boolean => {
  if (error instanceof Error && 'status' in error) {
    const status = (error as { status?: number }).status;
    if (status && status >= 400 && status < 500 && !RETRYABLE_4XX_STATUS_CODES.has(status)) {
      return false;
    }
  }
  return failureCount < MAX_RETRY_COUNT;
};
